// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"7d64a946","43":"a0301852","472":"8ed6188f","540":"a196b71c","651":"56380b89","653":"f217f8a2","862":"c6859b5f","887":"83667e8d","950":"7a0b2245"}[chunkId] + ".chunk.js";
};